import LoaderUI from './default/LoaderUI';
import DataStorage from '../storage/LocalStorage';
import { Utils } from '../Utils';

let TYPE = "default";
class ExternalAPI {

    get type(){
        // override this
        return TYPE;
    }

    get LoaderUI() {
        // override this if needed
        return LoaderUI;
    }

    get Storage() {
        // override this if needed
        return DataStorage;
    }

    constructor(config) {
        this.config = config || null;

        this.ready = false;

        this.exec = Utils.proxy(this.exec, this);
    }

    exec(method, ...args) {
        // override this if needed
        if (this[method] instanceof Function){
            return this[method](...args);
        }
    }

    init(callback){
        if (callback instanceof Function) {
            callback(this);
        }

        this.ready = true;
    }

    getMoreGamesURL() {
        return "http://playtomax.com";
    }
}

export default ExternalAPI;